<template>
	<div class="main">
		<section class="panel panel-default" style="margin-bottom: 0px;">
			<header class="panel-heading" style="padding: 10px;">
				<div class="panel-actions" style="top: 7px;">
					<a href="#searchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
				</div>
				<h4 class="panel-title">查詢條件</h4>
			</header>
      <div id="searchArea" class="panel-collapse collapse">
        <div class="panel-body">
          <div class="row form-group">
            <div class="col-md-12 ">
              <div class="col-md-4">
                <label class="col-md-4">學期</label>
                <div class="col-md-8">
                  <select v-model="query.smtr" class="form-control">
                    <option value="">--請選擇--</option>
                    <option v-for="(year, index) in selectYear()" :key="index" :value="year.value" :selected="index == 0">{{year.text}}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-4">
                <label class="col-md-4">學制</label>
                <div class="col-md-8">
                  <select v-model="query.deptSsym" class="form-control">
                    <option value="">--請選擇--</option>
                    <option v-for="(item, index) in ssymList" :key="index" :value="item.commCode">{{item.commValue}}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-4">
                <label class="col-md-4">科系</label>
                <div class="col-md-8">
                  <select v-model="query.deptCode" class="form-control">
                    <option value="">--請選擇--</option>
                    <option v-for="(item, index) in deptList" :key="index" :value="item.commCode">{{item.commValue}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-md-12 ">
              <div class="col-md-4">
                <label class="col-md-4">年級</label>
                <div class="col-md-8">
                  <select v-model="query.drade" class="form-control">
                    <option value="">--請選擇--</option>
                    <option v-for="(item, index) in dradeList" :key="index" :value="item.key">{{item.value}}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-4">
                <label class="col-md-4">學號</label>
                <div class="col-md-8">
                  <input type="text" class="form-control" v-model="query.account" />
                </div>
              </div>
              <div class="col-md-4">
                <label class="col-md-4">姓名</label>
                <div class="col-md-8">
                  <input type="text" class="form-control" v-model="query.name" />
                </div>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-md-12 ">
              <div class="col-md-4">
                <label class="col-md-4">負責區域</label>
                <div class="col-md-8">
                  <input type="text" class="form-control" v-model="query.mageArea" />
                </div>
              </div>
              <div class="col-md-4">
                <label class="col-md-4">宿舍</label>
                <div class="col-md-8">
                  <select v-model="query.area" class="form-control">
                    <option value="">--請選擇--</option>
                    <option v-for="(item, index) in bedFloorList" :key="index" :value="item">{{item}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-md-offset-4 col-md-4 ">
              <div class="col-md-offset-4 col-md-4">
                <button type="button" class="btn btn-danger btn-block" @click="updateGrid(1)">查詢</button>
              </div>
            </div>
          </div>
        </div>
      </div>
		</section>
		<div class="tab-content">
			<div class="row form-group">
				<div class="col-md-12 text-right form-inline">
					<label for="mageExcel">
						<div style="display:none;">
							<input type="file" id="mageExcel" name="mageExcel" @change="impMageRoster($event)" />
						</div>
						<a class="btn btn-danger">資料匯入</a>
						<a href="javascript:;" target="_blank" class="btn btn-danger" @click="downloadFile('幹部清單匯入範本.xlsx')">幹部清單匯入範本</a>
					</label>
				</div>
			</div>
			<div class="tab-pane fade in show" role="tabpanel" aria-labelledby="vacation-tab">
				<div class="row">
					<div class="col-md-12">
						<table class="table table-no-more table-bordered table-striped mb-none" >
							<thead>
								<tr>
                  <th class="text-center" width="5%">學期</th>
									<th class="text-center" width="10%">學制</th>
									<th class="text-center" width="20%">系科年級</th>
									<th class="text-center" width="15%">學號</th>
									<th class="text-center" width="10%">姓名</th>
									<th class="text-center" width="15%">負責區域</th>
									<th class="text-center" width="8%"></th>
                  <th class="text-center" width="8%" v-if="isAdmin('stay')"></th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in mageGrid" :key="index">
                  <td data-title="學期" class="text-center" >{{item.smtr}}</td>
                  <td data-title="學制" class="text-center" >{{item.deptSsymStr}}</td>
									<td data-title="系科年級" class="text-center" >{{item.deptCodeStr}}{{item.drade}}年{{item.dradeClass}}班</td>
									<td data-title="學號" class="text-center" >{{item.mageAccount}}</td>
									<td data-title="姓名" class="text-center" >
										<a class="btn btn-link" @click="gotoView('stay.mageDetail', {detList:item.detailList, mageAccount:item.mageAccount})">{{item.name}}</a>
									</td>
									<td data-title="負責區域" class="text-center" >
										{{item.mageArea}}
									</td>
									<td data-title="" class="text-center" >
										<a class="btn btn-link" @click="delMage(item)">刪除</a>
									</td>
                  <td>
                    <a class="btn btn-link" v-if="isAdmin('stay')" @click="exportCertification(item)">下載幹部證明</a>
                  </td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="col-md-12">
						<div class="text-center" v-if="isAdmin('stay')">
							<pageControl v-bind:page="page" v-bind:total="totalPage"></pageControl>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data(){
		return {
			mageGrid:{},
			page: 1,
			pageSize:10,
			totalPage:0,
			ssymList: [],
			deptList: [],
      bedFloorList: [],
			dradeList: [
				{ key: "1", value: "一年級" },
				{ key: "2", value: "二年級" },
				{ key: "3", value: "三年級" },
				{ key: "4", value: "四年級" },
				{ key: "5", value: "五年級" },
				{ key: "6", value: "六年級" },
				{ key: "7", value: "七年級" }
			],
      query: {
        smtr: "",
        deptSsym: "",
        deptCode: "",
        drade: "",
        account: "",
        name: "",
        mageArea: "",
        area: ""
      }
		}
	},
  mounted(){
    let _this = this;
    if (this.sessionData == null) {
      _this.$router.replace({ path: "/" });
    }
    //套用查詢設定
    const storeQryParam = JSON.parse(this.getStore(`${this.$route.name}.qryParam`));

    if(storeQryParam != null) {
      this.query.name = storeQryParam.name;
      this.query.smtr = storeQryParam.smtr;
      this.query.deptSsym = storeQryParam.deptSsym;
      this.query.deptCode = storeQryParam.deptCode;
      this.query.drade = storeQryParam.drade;
      this.query.account = storeQryParam.account;
      this.query.mageArea = storeQryParam.mageArea;
      this.query.area = storeQryParam.area;
    } else {
      this.query.smtr = this.nowSmtr;
    }
    const storePage = this.getStore(`${this.$route.name}.page`);
    if(storePage != null) {
      this.page = storePage;
    }

		this.mageInit();
		this.pageInit();
	},
	methods:{
		mageInit(){
			const api = "/api/RoomMage/mageInit";
			this.$axios.get(api).then(resp => {
				if(resp.data.status === "success"){
					this.ssymList = resp.data.data.ssymList;
					this.deptList = resp.data.data.deptList;
				}
			});
      const bedApi = "/api/RollcallRecord/bedList";
      this.$axios.post(bedApi, {}).then(resp => {
        this.bedFloorList = resp.data.data.bedFloorList;
      });
		},
		impMageRoster(e){
			const api = "/api/RoomMage/impMageRoster";
			if(e.target.files.length > 0){
				let excelFile = e.target.files[0];
				let formData = new FormData();
				formData.append("file", excelFile);
				let _this = this;
				this.$axios.post(api, formData).then(resp => {
					bootbox.alert(resp.data.msg.replace(new RegExp(/\r?\n/, "g"), "<br />" ), function(){
						if (resp.data.status === "success") {
							_this.pageInit();
						}
					});
				});
				e.target.value = "";
			}
		},
		updateGrid(page) {
			//更新Grid 必需
			this.page = page;
			this.pageInit();
		},
		pageInit(){
			const api = "/api/RoomMage/mageGrid";
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        model : this.query
      }
			this.$axios.post(api, JSON.stringify(param)).then(resp =>{
				this.mageGrid = resp.data.data.rows;
				this.totalPage = resp.data.data.total;
			});
		},
		delMage(param){
			let _this = this;
			bootbox.confirm("確定刪除此筆?", function(result){
				if(result){
					const api = `/api/RoomMage/delMage/${param.smtr}/${param.mageAccount}`;
					_this.$axios.delete(api).then(resp=>{
						let status = resp.data.status;
						bootbox.alert(resp.data.msg, function(){
							if(status == "success"){
								_this.pageInit();
							}

						});
					});
				}
			});
		},
    selectYear(){
      let smtrArray = [];
      let nowYear = (new Date().getFullYear() - 1911);
      let nowMonth = new Date().getMonth() + 1;
      if(nowMonth < 8){
        nowYear = nowYear-1;
      }
      for(let y = nowYear; y > 111 ; y--){
        smtrArray.push({text:y+"年第二學期",value:y+"2"});
        smtrArray.push({text:y+"年第一學期",value:y+"1"});
      }
      return smtrArray;
    },
    exportCertification(param){
      let url = `/api/RoomMage/exportCertification/${param.smtr}/${param.mageAccount}`;
      this.$http
        .post(url, {}, { responseType: "arraybuffer" })
        .then(res => {
          this.download2File(res);
        });
    }
	},
  beforeRouteLeave(to, from, next) {
    //保留查詢設定
    if(to.name === "stay.mageDetail") {
      this.setStore(`${this.$route.name}.qryParam`, {
        smtr: this.query.smtr,
        deptSsym: this.query.deptSsym,
        deptCode: this.query.deptCode,
        drade: this.query.drade,
        account: this.query.account,
        name: this.query.name,
        mageArea: this.query.mageArea,
        area: this.query.area
      });
      this.setStore(`${this.$route.name}.page`, this.page);
    } else {
      this.removeStore(`${this.$route.name}.page`);
      this.removeStore(`${this.$route.name}.qryParam`);
    }
    this.removeStore(this.$route.name);
    next();
  }
}
</script>
